module.exports = __webpack_public_path__ + "static/media/question_white.69600767.svg";